// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatFeedbackReason-modulereason__KpOtG AIButtonContainedGrey-moduleaiButtonContainedGrey__DeVYQ";
var _2 = "GretaAIChatFeedbackReason-modulereasonSelected__tzclO";
export { _1 as "reason", _2 as "reasonSelected" }
